// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"37dfd046","419":"f6e5e44c","635":"981bf7f6","741":"da50da35","787":"f271a177"}[chunkId] + ".chunk.js";
};